import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { environment } from '../../../environments/environment'

export interface SdwanNetworkSite {
  id: number
  code: string
  denominazione: string | null
  comune: string | null
  regione: string | null
  filiale: string | null
  polo: string | null
  /** Campi VLAN del Metafield (vlan_trunk, vlanlistX, vlandescrX). */
  fields: Record<string, string>
}

export interface SdwanNetworkFeed {
  generatedAt: string
  totalSites: number
  sites: SdwanNetworkSite[]
}

@Injectable({
  providedIn: 'root'
})
export class AwpSdwanNetworkApiService {
  private readonly http = inject(HttpClient)
  private readonly fuseqHeaders = inject(FuseqHeaders)

  getVlans (): Observable<SdwanNetworkFeed> {
    return this.http.get<SdwanNetworkFeed>(
      `${environment.API_URL}/sdwanNetwork/vlans`,
      this.fuseqHeaders.setTokenHeaders('GET')
    )
  }
}
